import React, { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

// Grid cell for picking several options; shows the chosen labels joined for the cell text.
export default function MultiSelectCell({
  values = [],
  options = [],
  onChange,
  placeholder = "—",
  disabled = false,
  joinWith = " x ",
}) {
  const [open, setOpen] = useState(false);
  const labelOf = (v) => options.find((o) => o.value === v)?.label ?? v;
  const toggle = (v) =>
    onChange(
      values.includes(v) ? values.filter((x) => x !== v) : [...values, v]
    );
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          className="flex w-full min-w-[170px] items-center justify-between gap-2 bg-transparent py-1.5 px-2 text-left text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-inset disabled:cursor-not-allowed disabled:text-gray-400"
        >
          <span
            className={`truncate ${values.length ? "" : "text-muted-foreground"}`}
          >
            {values.length ? values.map(labelOf).join(joinWith) : placeholder}
          </span>
          <ChevronDown className="h-3.5 w-3.5 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-56 p-1">
        {options.length === 0 && (
          <p className="px-2 py-2 text-sm text-muted-foreground">
            {placeholder}
          </p>
        )}
        {options.map((o) => {
          const on = values.includes(o.value);
          return (
            <button
              key={o.value}
              type="button"
              onClick={() => toggle(o.value)}
              className="flex w-full items-center justify-between rounded-sm px-2 py-1.5 text-sm hover:bg-accent"
            >
              <span>{o.label}</span>
              {on && <Check className="h-4 w-4 text-primary" />}
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
